import { gql } from '@apollo/client';

const updateByIdCourseMetricDefinitionMutation = gql`
  mutation UpdateByIdCourseMetricDefinition($_id: MongoID!, $record: CourseMetricDefinitionInput!) {
    updateByIdCourseMetricDefinition(_id: $_id, record: $record) {
      record {
        _id
        key
        order
        uiType
      }
    }
  }
`;

export default updateByIdCourseMetricDefinitionMutation;
